export const driversData = [
  {
    key: "1",
    IMAGE: "customer-01.jpg",
    DRIVERS: "Reuben Keen",
    PHONE: "+1 14782 14578",
    EMAIL: "reuben@example.com",
    LICENSE_NO: "DL123456789",
    EXPIRY_DATE: "24 Jan 2025",
    STATUS: "Active",
  },
  {
    key: "2",
    IMAGE: "customer-02.jpg",
    DRIVERS: "William Jones",
    PHONE: "+1 32569 15458",
    EMAIL: "william@example.com",
    LICENSE_NO: "DL1697453622",
    EXPIRY_DATE: "19 Dec 2024",
    STATUS: "Inactive",
  },
  {
    key: "3",
    IMAGE: "customer-03.jpg",
    DRIVERS: "Leonard Jandreau",
    PHONE: "+1 25669 88985",
    EMAIL: "leonard@example.com",
    LICENSE_NO: "DL5694863152",
    EXPIRY_DATE: "11 Dec 2024",
    STATUS: "Active",
  },
  {
    key: "4",
    IMAGE: "customer-04.jpg",
    DRIVERS: "Adam Bolden",
    PHONE: "+1 54698 55468",
    EMAIL: "adam@example.com",
    LICENSE_NO: "DL234567890",
    EXPIRY_DATE: "29 Nov 2024",
    STATUS: "Active",
  },
  {
    key: "5",
    IMAGE: "customer-05.jpg",
    DRIVERS: "Harvey Jimenez",
    PHONE: "+1 12488 14457",
    EMAIL: "harvey@example.com",
    LICENSE_NO: "DL678901234",
    EXPIRY_DATE: "03 Nov 2024",
    STATUS: "Active",
  },
  {
    key: "6",
    IMAGE: "customer-06.jpg",
    DRIVERS: "William Ward",
    PHONE: "+1 65895 47878",
    EMAIL: "william@example.com",
    LICENSE_NO: "DL012345678",
    EXPIRY_DATE: "31 Oct 2024",
    STATUS: "Inactive",
  },
  {
    key: "7",
    IMAGE: "customer-07.jpg",
    DRIVERS: "Norman Coleman",
    PHONE: "+1 32569 15458",
    EMAIL: "norman@example.com",
    LICENSE_NO: "DL987654321",
    EXPIRY_DATE: "15 Oct 2024",
    STATUS: "Inactive",
  },
  {
    key: "8",
    IMAGE: "customer-08.jpg",
    DRIVERS: "Jay Beckman",
    PHONE: "+1 56598 98956",
    EMAIL: "jaybeckman@example.com",
    LICENSE_NO: "DL345678901",
    EXPIRY_DATE: "26 Sep 2024",
    STATUS: "Active",
  },
  {
    key: "9",
    IMAGE: "customer-09.jpg",
    DRIVERS: "Francis Harris",
    PHONE: "+1 12781 02567",
    EMAIL: "francis@example.com",
    LICENSE_NO: "DL456789012",
    EXPIRY_DATE: "01 Sep 2024",
    STATUS: "Active",
  },
  {
    key: "10",
    IMAGE: "customer-10.jpg",
    DRIVERS: "Renaldo Labarre",
    PHONE: "+1 12124 14255",
    EMAIL: "renaldo@example.com",
    LICENSE_NO: "DL567890123",
    EXPIRY_DATE: "15 Aug 2024",
    STATUS: "Active",
  },
];
